"use client";
import { useCallback, useRef, useState } from "react";
import styles from "./BeyondScreenCarouselComponentMobileHomeNew.module.scss";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";
import clsx from "clsx";
import LeftArrowNoTail from "@/SvgIcons/LeftArrowNoTail";
import RightArrowNoTail from "@/SvgIcons/RightArrowNoTail";
import { addStaticSubdomain } from "@/revamp/molecules/ProgramCard/utils";

const IMAGES_LIST = [
  "https://amityonline.com/_s/samagam_2_ecd0757f87.webp",
  "https://amityonline.com/_s/samagam_4_9552ff4b02.webp",
  "https://amityonline.com/_s/samagam_6_0a3ea86e90.webp",
  "https://amityonline.com/_s/samagam_7_fd8d550a1a.webp",
  "https://amityonline.com/_s/samagam_1_59f52cbc30.webp",
  "https://amityonline.com/_s/samagam_3_e5b335022b.webp",
  "https://amityonline.com/_s/samagam_5_024ad270c3.webp",
  "https://amityonline.com/_s/Mid_Year_Meetup_2_83b2773245.webp",
  "https://amityonline.com/_s/Mid_Year_Meetup_4_dfa96a86e7.webp",
  "https://amityonline.com/_s/IMG_3853_0961d683c3.webp",
  "https://amityonline.com/_s/IMG_3708_3a0d949668.webp",
  "https://amityonline.com/_s/Mid_Year_Meetup_ba7a1ea3f2.webp",
  "https://amityonline.com/_s/Mid_Year_Meetup_3_264a28f631.webp",
  "https://amityonline.com/_s/Mid_Year_Meetup_1_ac548ae8e4.webp",
  "https://amityonline.com/_s/0_G4_A2784_9d9b51f760.webp",
  "https://amityonline.com/_s/0_G4_A2899_56be1bd3cc.webp",
  "https://amityonline.com/_s/0_G4_A2853_0fd242a998.webp",
  "https://amityonline.com/_s/0_G4_A2940_cfdcd50810.webp",
  "https://amityonline.com/_s/0_G4_A2918_3d393b5e60.webp",
  "https://amityonline.com/_s/0_G4_A2883_648ced6ced.webp",
  "https://amityonline.com/_s/0_G4_A2842_acffeed8f4.webp",
  "https://amityonline.com/_s/0_G4_A0382_f1782ad9ea.webp",
  "https://amityonline.com/_s/NIL_05387_6d7afc6d29.webp",
  "https://amityonline.com/_s/NIL_05145_6cb54365db.webp",
  "https://amityonline.com/_s/0_G4_A0151_9d09c85855.webp",
  "https://amityonline.com/_s/0_G4_A9441_0d68944ad1.webp",
  "https://amityonline.com/_s/IMG_6118_d6573fc77f.webp",
  "https://amityonline.com/_s/0_G4_A1555_686e504227.webp",
];

const BeyondScreenCarouselComponentMobile = () => {
  return (
    <div className={styles.container}>
      <h2>Beyond Screens: Experience On Campus Learning With Amity Online</h2>
      <h3>Bring your learning to life with real-world campus experiences, events, and industry exposure.</h3>

      <CarouselComponent />
    </div>
  );
};

const CarouselComponent = () => {
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.prevSlide();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.nextSlide();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsAtStart(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };

  return (
    <div className={clsx(styles.careerOnlineCaruContainer, "relative")}>
      <Carousel
        ref={sliderRef}
        config={{
          autoplay: { status: false },
          spaceBetween: 12,
          slidesPerView: 2,
          pagination: {
            status: false,
            className: `${styles.bulletsContainer} revamp_carousel_pagination`,
          },
          breakpoints: {
            0: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            520: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          },
          onSlideChange: ({ isBeginning, isEnd }) => handleSlideChange({ isBeginning, isEnd }),
        }}
        className={`${styles.careersCarouselWrapper} relative`}
        slidesContainerClassName={styles.slidesContainer}
        slideWrapperClassName={styles.slideWrapper}
        isSmoothBehaviour={true}
        id="holistics-career"
      >
        {IMAGES_LIST.map((item) => {
          return (
            <div key={item} className={styles.careersOnlineItem}>
              <img
                src={addStaticSubdomain(item)}
                alt="amity online"
                height={184}
                width={184}
                className={styles.cardImg}
                loading="lazy"
                decoding="async"
              />
            </div>
          );
        })}
      </Carousel>
      <button
        className={clsx(styles.prevArrow)}
        onClick={handlePrev}
        disabled={isAtStart}
        aria-label="Previous"
      >
        <LeftArrowNoTail width={10} height={10} />
      </button>
      <button
        className={clsx(styles.nextArrow)}
        onClick={handleNext}
        aria-label="Next"
        disabled={isAtEnd}
      >
        <RightArrowNoTail width={10} height={10} />
      </button>
    </div>
  );
};

export default BeyondScreenCarouselComponentMobile;
